module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2026-08-05 at 10.38.55.c42b9f73.jpeg";